import { Helmet } from "react-helmet-async";
import { config } from "@/lib/config";
import "./LegalPages.css";

export function LegalPage() {
  return (
    <>
      <Helmet>
        <title>Terms of service · {config.appName}</title>
        <link rel="canonical" href={`${config.publicSiteUrl}/terms`} />
      </Helmet>
      <article className="legal-page">
        <h1 className="legal-page__title">Terms of service</h1>
        <p className="legal-page__meta">
          Last updated placeholder — replace with counsel-approved copy before production.
        </p>
        <section className="legal-page__section">
          <h2>Acceptance</h2>
          <p>
            By accessing {config.siteHostname}, you agree to these terms and to comply with all
            applicable laws. This is placeholder content for enterprise review and must be replaced
            with jurisdiction-specific legal language.
          </p>
        </section>
        <section className="legal-page__section">
          <h2>Age and eligibility</h2>
          <p>
            You must be 21 or older. We may require verification at delivery. Service is offered
            only where permitted by law.
          </p>
        </section>
        <section className="legal-page__section">
          <h2>Orders and pricing</h2>
          <p>
            Menu items, availability, and prices are subject to change. Taxes and fees may apply.
            Placeholder — add refund, cancellation, and dispute policies.
          </p>
        </section>
      </article>
    </>
  );
}
